// Dates com a cadenes 'AAAA-MM-DD' i dies naturals en UTC: el preu d'una nit no pot dependre
// de la zona horària del navegador que fa la previsualització (§6).
const DAY_MS = 86_400_000;
const ISO_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
/** Dia natural (dies des de l'1-1-1970) d'una data 'AAAA-MM-DD'. */
export function toDay(iso) {
    const m = ISO_RE.exec(iso);
    if (!m)
        throw new Error(`invalid date: ${iso}`);
    return Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])) / DAY_MS;
}
export function fromDay(day) {
    return new Date(day * DAY_MS).toISOString().slice(0, 10);
}
export function isIsoDate(value) {
    if (!ISO_RE.test(value))
        return false;
    return fromDay(toDay(value)) === value;
}
export function addDays(iso, n) {
    return fromDay(toDay(iso) + n);
}
/** Dies del mes (`month0`: 0 = gener). Té en compte els anys de traspàs. */
export function daysInMonth(year, month0) {
    return new Date(Date.UTC(year, month0 + 1, 0)).getUTCDate();
}
/** Any i mes (0–11) d'un dia natural. */
export function yearMonth(day) {
    const d = new Date(day * DAY_MS);
    return { year: d.getUTCFullYear(), month0: d.getUTCMonth() };
}
